enum ActivatedEInvoices {
  All,
  Some,
  None,
}

export default ActivatedEInvoices